import React, {
  useContext,
  useEffect,
  useState
} from "react";

import { TranslatorContext } from "../../context/Translator";

import {
  AnchorComponent
} from "../elements";


export default function ACTGroupTableComponent({
  thead,
  tbody
}) {

  const { t } = useContext(TranslatorContext);

  const [data, setData] = useState([]);

  const [searchQuery, setSearchQuery] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const itemsPerPage = 10;


  /*
   * Update table whenever parent data changes
   */
  useEffect(() => {

    setData(tbody || []);

  }, [tbody]);


  /*
   * Search
   */
  const handleSearch = (event) => {

    setSearchQuery(
      event.target.value.toLowerCase()
    );

    setCurrentPage(1);

  };


  /*
   * Filter
   */
  const filteredData = data.filter((item) => {

    return Object.entries(item).some(
      ([key, value]) => {

        // Don't search inside action object
        if (key === "action") {
          return false;
        }

        return String(value ?? "")
          .toLowerCase()
          .includes(searchQuery);

      }
    );

  });


  /*
   * Pagination
   */
  const totalItems =
    filteredData.length;

  const totalPages =
    Math.ceil(
      totalItems / itemsPerPage
    );

  const startIndex =
    (currentPage - 1) *
    itemsPerPage;

  const paginatedData =
    filteredData.slice(
      startIndex,
      startIndex + itemsPerPage
    );


  const handlePageChange = (page) => {

    if (
      page > 0 &&
      page <= totalPages
    ) {

      setCurrentPage(page);

    }

  };


  /*
   * Amount formatter
   */
  const formatAmount = (amount) => {

    if (
      amount === null ||
      amount === undefined ||
      amount === ""
    ) {
      return "-";
    }

    return Number(amount).toLocaleString(
      "en-PK"
    );

  };


  /*
   * Date formatter
   */
  const formatDate = (date) => {

    if (!date) {
      return "-";
    }

    const parsed = new Date(date);

    if (isNaN(parsed.getTime())) {
      return date;
    }

    return parsed.toLocaleDateString(
      "en-GB"
    );

  };


  return (

    <>

      <div className="mc-table-responsive">

        {/* Search */}

        <div className="mc-search">

          <input
            type="text"
            placeholder={
              t("search") ||
              "Search ACT Groups"
            }
            value={searchQuery}
            onChange={handleSearch}
            className="form-control table-search"
          />

        </div>


        {/* Table */}

        <table className="mc-table product">

          <thead
            className="mc-table-head"
            style={{
              backgroundColor: "#077834",
              color: "white"
            }}
          >

            <tr>

              {thead.map(
                (item, index) => (

                  <th key={index}>
                    {t(item)}
                  </th>

                )
              )}

            </tr>

          </thead>


          <tbody className="mc-table-body even">

            {paginatedData.length > 0 ? (

              paginatedData.map(
                (item, index) => (

                  <tr key={item.id}>
                    <td>{item.group_code}</td>
                    {/* Group Name */}

                    <td>

                      <div className="mc-table-product md">

                        <div className="mc-table-group">

                          <h6>
                            <p>
                              {item.group_name}
                            </p>
                          </h6>

                        </div>

                      </div>

                    </td>


                    {/* City */}

                    <td>
                      <p>
                        {item.city}
                      </p>
                    </td>


                  


                    {/* Gender */}

                    <td>

                      <p>
                        {item.gender}
                      </p>

                    </td>


                    {/* Date */}

                    <td>

                      <p>
                        {formatDate(
                          item.date
                        )}
                      </p>

                    </td>


                    {/* Amount */}

                    <td>

                      <div className="mc-table-price">

                        <p>
                          PKR{" "}
                          {formatAmount(
                            item.agreed_amount
                          )}
                        </p>

                      </div>

                    </td>


                  



                 
                    {/* Members */}

                    <td>

                      <span
                        className="badge bg-success"
                      >
                        {item.members_count}
                      </span>

                    </td>


                    {/* Meetings */}

                    <td>

                      <span
                        className="badge bg-info"
                      >
                        {item.meetings_count}
                      </span>

                    </td>


                    {/* Actions */}

                    <td>

                      <div className="mc-table-action">

                        {/* View */}

                        <AnchorComponent
                          to={`/act-groups/view/${item.id}`}
                          title="View"
                          className="material-icons view"
                          style={{
                            backgroundColor:
                              "rgba(7, 120, 52, 0.7)",
                            color: "#fff"
                          }}
                        >

                          {item.action.view}

                        </AnchorComponent>


                        {/* Edit */}

                        <AnchorComponent
                          to={`/act-groups/edit/${item.id}`}
                          title="Edit"
                          className="material-icons edit"
                        >

                          {item.action.edit}

                        </AnchorComponent>


                        {/* Give Loan */}

                        <AnchorComponent
                          to={`/act-groups/loans/${item.id}`}
                          title="Give Loan"
                          className="material-icons view"
                          style={{
                            backgroundColor:
                              "rgba(13, 110, 253, 0.7)",
                            color: "#fff"
                          }}
                        >

                          payments

                        </AnchorComponent>

                      </div>

                    </td>

                  </tr>

                )
              )

            ) : (

              <tr>

                <td
                  colSpan={thead.length}
                  style={{
                    textAlign: "center",
                    padding: "30px"
                  }}
                >

                  No ACT Groups Found

                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>


      {/* Pagination */}

      {totalItems > 0 && (

        <div className="mc-paginate">

          <p className="mc-paginate-title">

            {t("showing")}

            <b>
              {" "}
              {startIndex + 1}{" "}
            </b>

            {t("to")}

            <b>
              {" "}
              {Math.min(
                startIndex +
                  itemsPerPage,
                totalItems
              )}{" "}
            </b>

            {t("of")}

            <b>
              {" "}
              {totalItems}{" "}
            </b>

            {t("results")}

          </p>


          <ul
            className="mc-paginate-list"
            style={{
              listStyle: "none",
              padding: 0
            }}
          >

            {/* Previous */}

            <li
              style={{
                color: "#077834",
                backgroundColor: "#e8f5e9",
                borderRadius: "4px",
                padding: "5px 10px",
                cursor:
                  currentPage === 1
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  currentPage === 1
                    ? 0.5
                    : 1
              }}
              onClick={() =>
                handlePageChange(
                  currentPage - 1
                )
              }
            >

              <i className="material-icons">
                chevron_left
              </i>

            </li>


            {/* Page Numbers */}

            {[...Array(totalPages)].map(
              (_, index) => {

                const page =
                  index + 1;

                const isActive =
                  page ===
                  currentPage;

                return (

                  <li
                    key={page}
                    className="mc-paginate-item"
                    style={{
                      backgroundColor:
                        isActive
                          ? "#077834"
                          : "#e8f5e9",

                      color:
                        isActive
                          ? "#fff"
                          : "#077834",

                      borderRadius:
                        "4px",

                      padding:
                        "5px 10px",

                      margin:
                        "0 4px",

                      cursor:
                        "pointer"
                    }}
                    onClick={() =>
                      handlePageChange(
                        page
                      )
                    }
                  >

                    {page}

                  </li>

                );

              }
            )}


            {/* Next */}

            <li
              style={{
                color: "#077834",
                backgroundColor: "#e8f5e9",
                borderRadius: "4px",
                padding: "5px 10px",

                cursor:
                  currentPage ===
                  totalPages
                    ? "not-allowed"
                    : "pointer",

                opacity:
                  currentPage ===
                  totalPages
                    ? 0.5
                    : 1
              }}
              onClick={() =>
                handlePageChange(
                  currentPage + 1
                )
              }
            >

              <i className="material-icons">
                chevron_right
              </i>

            </li>

          </ul>

        </div>

      )}

    </>

  );
}